import Modal from "@/components/entities/modal";
import { FC } from "react";
import SupportForm from "../../support-form";
import CloseButton from "@/components/ui/close-button";
import S from "./index.module.scss";
import { FeedbackResourceFormEnum } from "@/api/generated-api";

interface ISupportModal {
  onClose(): void;
  form: FeedbackResourceFormEnum;
  title?: string;
}

const SupportModal: FC<ISupportModal> = ({ onClose, title, form }) => {
  return (
    <Modal onClose={onClose}>
      <div className={S.content}>
        <CloseButton onClose={onClose} />
        <SupportForm title={title} form={form} />
      </div>
    </Modal>
  );
};

export default SupportModal;
